import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { getAdById, activateAd } from '../../actions/adActions';

// Components
import Spinner from '../../components/common/Spinner';

// Imgs
import processingImg from '../../utils/imgs/processing-image.png';

const StripeSuccessPage = ({ 
    ad,
    getAdById,
    activateAd,
    match
}) => {

    // State variable for tracking Mixpanel event
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Get the current URL
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;

    // Get the value of the 'email' query parameter from the URL
    const session_id = url.searchParams.get("session_id");

    useEffect(() => {
    
        // Fetch the post data based on the `match.params.id` parameter
        getAdById(session_id);

    }, [ session_id ]);

    useEffect(() => {
    
        // activate ad
        if(ad.ad && ad.ad.status == "checkout") {
            activateAd(ad.ad, true);
        }

    }, [ ad.ad ]);

    // Redirect to home if user is already logged in
    if((!ad.loading && ad.ad == null) || (ad.ad && ad.ad.status === "active")) {
        window.location.href = `/post/${match.params.id}`;
    }

     // Initialize and track Mixpanel event for claim account page view
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Successful Ad Payment Page View");
    }

    // Send Mixpanel event only in production and if not already sent
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

  return (
    <div className='email_link_page'>
        {/* Title */}
        <p style={{color:'rgb(20, 20, 20)', marginBottom:'0', marginTop:'0', fontSize:'32px', lineHeight:'40px', fontWeight:'700', letterSpacing:'-0.4px'}}>
            Payment Success!
        </p>
        {/* Loading indicator */}
        <div>
            <Spinner />
        </div>
        <p style={{color:'gray', marginTop:'10px', marginBottom:'32px', fontSize:'16px', fontWeight:'500', lineHeight:'24px', letterSpacing:'-0.4px'}}>
            We're boosting your post... This may take a few seconds.
        </p>

        {/* Additional information */}
        <p style={{color:'rgb(49, 50, 51)', marginTop:'32px', marginBottom:'32px', fontSize:'16px', fontWeight:'500', lineHeight:'24px', letterSpacing:'-0.4px'}}>
            You’ll be redirected when it's done, please do not close this tab.
        </p>

        {/* Image */}
        <img src={processingImg} />
    </div>
  )
}

StripeSuccessPage.propTypes = {
    ad: PropTypes.object.isRequired,
    getAdById: PropTypes.func.isRequired,
    activateAd: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    ad: state.ad,
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    getAdById,
    activateAd
})(StripeSuccessPage);